import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import { RootState } from "@/store/index";

import Tag from "@/components/common/tag/tag";
import { courseStatus } from "@/pages/dashboard/constants";

import Clock from "@/assets/icons/clock.png";
import WhiteClock from "@/assets/icons/whiteClock.png";

import RedActionReq from "@/assets/icons/redActionReq.png";
import GreenTick from "@/assets/icons/greenTick.png";
import WhiteLock from "@/assets/icons/whiteLock.png";
import { useLocalTranslation } from "@/hooks/useLocalTranslation";

import moment from "moment";
import { addCurrentThemeClassToEle } from "@/utils";
import "./courseCard.css";
import { themes } from "@/constants/colors_v2";
import { idVerificationProofStatus } from "@/pages/profile/sections/idVerification/constants";
import { nocStatus } from "@/pages/timeline/sections/timeline/timelineSections/noc/constants";

export default function CourseCard(props: any) {
  const navigate = useNavigate();

  /**
        course status : ["enrolled", "active", "completed"]
        
        actionRequired:
            isVerificationIncomplete : true  || isBssIncomplete : true || installmentOverdue : true             
        Lock Icons : 
            If any one installmentOverdue : true
            But except the one where actionRequired : true  
        
            
        Text on various status: 
            if(completed) ? Completed on 21st Feb, 2025 : Enrolled on 27th Sep, 2024

    */

  const { common } = useLocalTranslation();

  const screenWidth = useSelector(
    (state: RootState) => state.screenWidthReducer.screenWidth
  );
  const currentTheme = useSelector(
    (state: RootState) => state.currentThemeReducer.currentTheme
  );

  const [courseIsCompleted, setCourseIsCompleted] = useState(false);
  const [courseIsActionReq, setCourseIsActionReq] = useState(false);
  const [lockCourse, setLockCourse] = useState(false);
  const [tagDetails, setTagDetails] = useState({
    text: "",
    icon: "",
    colorCode: "",
  });

  const imageSrc =
    screenWidth > 500
      ? props.course.rectangleThumbnailUrl
      : props.course.squareThumbnailUrl;

  useEffect(() => {
    updateCourseStatus();
  }, [props.course]);

  const isBSSFormRequiredAndNotCompleted = (course: any) => {
    let ret = false;
    if (course.isBSSFormRequired) {
      if (props.course.isBssIncomplete) {
        ret = true;
      }
    }
    return ret;
  };

  const isNocRequiredAndNotCompleted = (course: any) => {
    let ret = false;
    if (course.isNocRequired) {
      if (
        props.course.nocDocumentStatus === nocStatus.not_submitted ||
        props.course.nocDocumentStatus === nocStatus.rejected
      ) {
        ret = true;
      }
    }
    return ret;
  };

  function lockTheCourse(courses: any, courseId: any) {
    return courses.some((course: any) => {
      if (course.courseId === courseId) {
        return false; // skip the current course
      }

      if (
        course.currentProfileState === idVerificationProofStatus.unVerified ||
        course.currentProfileState === idVerificationProofStatus.rejected
      ) {
        return true;
      }

      if (course.installmentOverdue) {
        return true;
      }

      if (isBSSFormRequiredAndNotCompleted(course)) {
        return true;
      }

      // un-comment if noc case req
      // if (isNocRequiredAndNotCompleted(course)) {
      //     return true;
      // }

      return false;
    });
  }

  const updateCourseStatus = () => {
    const logic: any = "v1";
    // new code
    if (logic === "v2") {
      const currentCourse = props.course;
      // console.log(props.allCourses)

      if (currentCourse) {
        // ----- START :: isActionReq  ----
        let isActionReq = false;
        if (currentCourse.installmentOverdue) {
          isActionReq = true;
        }

        if (
          currentCourse.courseStatus === courseStatus.enrolled &&
          currentCourse.currentProfileState ===
            idVerificationProofStatus.unVerified
        ) {
          isActionReq = true;
        }

        if (
          currentCourse.currentProfileState ===
          idVerificationProofStatus.rejected
        ) {
          isActionReq = true;
        }

        if (isBSSFormRequiredAndNotCompleted(currentCourse)) {
          isActionReq = true;
        }

        // un-comment is noc case is req
        // if(isNocRequiredAndNotCompleted(currentCourse)){
        //     isActionReq = true
        // }

        if (isActionReq) {
          setCourseIsActionReq(true);
          const tagDetailsTemp = {
            text: common.status.actionRequired,
            icon: RedActionReq,
            colorCode: "red",
          };
          setTagDetails(tagDetailsTemp);
          return;
        }
        // ----- END :: isActionReq  ----

        // ----- START :: CourseIsCompleted  ----
        if (
          currentCourse === courseStatus.completed &&
          props.course.courseCompletedAt
        ) {
          setCourseIsCompleted(true);
          const tagDetailsTemp = {
            text: common.status.completed,
            icon: GreenTick,
            colorCode: "green",
          };
          setTagDetails(tagDetailsTemp);
          // if (props.anyOneInstallmentOverDue) {
          //     setLockCourse(true)
          // }
          return;
        }
        // ----- END :: CourseIsCompleted  ----

        const lockTheCourse_ = lockTheCourse(
          props.allCourses,
          currentCourse.courseId
        );
        if (lockTheCourse_) {
          setLockCourse(lockTheCourse_);
          return;
        }
      }

      if (props.anyOneInstallmentOverDue) {
        setLockCourse(true);
      }
    }

    // old code
    if (logic === "v1") {
      if (
        props.course &&
        props.course.courseStatus &&
        props.course.courseStatus === courseStatus.completed &&
        props.course.courseCompletedAt
      ) {
        setCourseIsCompleted(true);
        const tagDetailsTemp = {
          text: common.status.completed,
          icon: GreenTick,
          colorCode: "green",
        };
        setTagDetails(tagDetailsTemp);
        // if (props.anyOneInstallmentOverDue) {
        //   setLockCourse(true);
        // }
        return;
      }
      if (
        props.course &&
        (props.course.isVerificationIncomplete ||
          isBSSFormRequiredAndNotCompleted(props.course) ||
          props.course.installmentOverdue)
      ) {
        // console.log(props.course)
        setCourseIsActionReq(true);
        const tagDetailsTemp = {
          text: common.status.actionRequired,
          icon: RedActionReq,
          colorCode: "red",
        };
        setTagDetails(tagDetailsTemp);
        return;
      }

      if (!props.course.installmentOverdue) {
        if (props.anyOneInstallmentOverDue) {
          setLockCourse(true);
        }
      }
    }
  };

  const handleCourseRedirect = () => {
    if (!lockCourse) {
      navigate(`/timeline/${props.course.purchaseId}`);
    }
  };

  return (
    <div
      onClick={handleCourseRedirect}
      style={{ cursor: lockCourse ? "not-allowed" : "pointer" }}
      className={`courseCardMain h-fit shadow-[0px_2px_4px_0px_#0000001A] rounded-bl-[10px] rounded-br-[10px] ${addCurrentThemeClassToEle(
        currentTheme,
        "courseMain"
      )}`}
    >
      <div className="relative">
        <img
          src={imageSrc}
          alt="courseCard"
          className="block rounded-t-[7px] rounded-b-[7px]"
        />
        {(courseIsCompleted || courseIsActionReq) && (
          <div className="absolute bottom-2 left-0">
            <Tag
              text={tagDetails.text}
              icon={tagDetails.icon}
              colorCode={tagDetails.colorCode}
              borderR_tr="5px"
              borderR_br="5px"
              iconWidth="10px"
              setBoxShow="rgba(226, 225, 225, 0.55) 1px 2px 5px 1px"
              textSize="13px"
            />
          </div>
        )}

        {lockCourse && (
          <div>
            <div className="absolute inset-0 bg-black/30 rounded-[7px]" />
            <img
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[28px]"
              src={WhiteLock}
              alt="Overlay icon"
            />
          </div>
        )}
      </div>

      <div className="px-[10px] py-[13px] rounded-bl-[10px] rounded-br-[10px] border-b border-l border-r -mt-1 courseCardMain1">
        <p className="text-[15px] font-normal truncate w-[100%]">
          {props.course.title}
        </p>
        <hr className="mt-[8px] mb-[8px]" />
        <div className="flex items-center">
          <img
            className="w-[20px] h-[20px] mr-[5px]"
            src={currentTheme === themes.light ? Clock : WhiteClock}
            alt="clock"
          />
          <p className="text-[14px] font-normal truncate w-[100%]">
            {props.course.courseCompletedAt
              ? common.statusText.completedOn
              : common.statusText.enrolledOn}
            <span className="font-medium ml-[2px]">
              {moment(props.course.createdAt).format("Do MMM, YYYY")}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
